import { LightningElement, track, api } from "lwc";
import { t } from "tbme/localization";
import {
  DigitalResume,
  getDigitalResume,
  DigitalResumeResponse,
} from "../../../shared/experienceApi";
import { getConfig } from "tbme/clientAdapter";

export const CAREER_MARKETPLACE_URL_MAP: { [index: string]: string } = {
  DEV: "https://dev.trailhead.sfdc.sh",
  QA: "https://dev.trailhead.sfdc.sh",
  EXT: "https://ext.trailhead.sfdc.sh",
  UAT: "https://stg.trailhead.sfdc.sh",
  PROD: "https://trailhead.salesforce.com",
};
export default class extends LightningElement {
  @api
  userId = "";
  isVisible = false;
  @track
  digitalResume?: DigitalResume;

  get CAREER_MARKETPLACE_BASE_URL(): string {
    return (
      CAREER_MARKETPLACE_URL_MAP[window.sfdcBase?.env as string] ??
      CAREER_MARKETPLACE_URL_MAP["PROD"]
    );
  }

  get isEnrolled(): boolean {
    return this.digitalResume ? true : false;
  }

  get isCareerModeEnabled(): boolean {
    return this.digitalResume?.showInSearchResults === true;
  }

  get buttonLink(): string {
    return this.isEnrolled
      ? this.isCareerModeEnabled
        ? `${this.CAREER_MARKETPLACE_BASE_URL}/careers/users/${this.userId}`
        : `${this.CAREER_MARKETPLACE_BASE_URL}/careers/users/${this.userId}`
      : `${this.CAREER_MARKETPLACE_BASE_URL}/careers/users/${this.userId}?source=profile`;
  }

  get buttonText(): string {
    return this.isEnrolled
      ? this.isCareerModeEnabled
        ? t("careerMarketplace.buttonEnrolledCareerModeOn")
        : t("careerMarketplace.buttonEnrolledCareerModeOff")
      : t("careerMarketplace.buttonUnenrolled");
  }

  get title(): string {
    return t("careerMarketplace.title");
  }

  get containerClass(): string {
    return this.isEnrolled
      ? "cm-container cm-top-border"
      : "cm-container cm-bordered";
  }

  get careerModeStatusText(): string {
    return this.isCareerModeEnabled
      ? t("careerMarketplace.statusOn")
      : t("careerMarketplace.statusOff");
  }

  get bodyText(): string {
    return this.isEnrolled
      ? this.isCareerModeEnabled
        ? t("careerMarketplace.bodyEnrolledCareerModeOn", {
            careerMarketplaceLink: `${this.CAREER_MARKETPLACE_BASE_URL}/careers`,
            settingsLink: "/trailblazer/settings",
          })
        : t("careerMarketplace.bodyEnrolledCareerModeOff", {
            careerMarketplaceLink: `${this.CAREER_MARKETPLACE_BASE_URL}/careers`,
            settingsLink: "/trailblazer/settings",
          })
      : t("careerMarketplace.bodyUnenrolled", {
          careerMarketplaceLink: `${this.CAREER_MARKETPLACE_BASE_URL}/careers`,
        });
  }

  async connectedCallback() {
    const accessToken = getConfig().accessToken;
    getDigitalResume(accessToken)
      .then((response: DigitalResumeResponse) => {
        if (response.data?.digitalResume) {
          this.digitalResume = response.data.digitalResume;
        }
      })
      .finally(() => {
        this.isVisible = true;
      });
  }
}
